import { ButtonProps } from '@my/ui'
import { color } from '@my/util'

export const buttonStyle: ButtonProps = {
  '$platform-native': { zi: -1 },
  fontSize: 17,
  width: 120,
  borderRadius: 15,
  fontWeight: '700',
  color: color.white,
  backgroundColor: color.tzaGreen,
}

export const shadowGenerator: any = (shadow = 0.3, percentage = 25) => ({
  '$platform-android': {
    elevation: shadow * 25,
  },
  shadowColor: `rgba(0, 0, 0, ${percentage})`,
  shadowOffset: { width: 0, height: 3 },
  shadowOpacity: shadow,
  shadowRadius: 5,
  boxShadow: `0px 0px 0px rgba(0, 0, 0, ${shadow})`, // Box shadow for container in web
})
